(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll(".related-products:not([data-loaded])").forEach(function (container) {
    container.setAttribute("data-loaded", "true");
    var productId = container.dataset.productId;
    var sectionId = container.dataset.sectionId;
    var limit = container.dataset.limit || 4;
    if (!productId || !sectionId) return;
    var url = "/recommendations/products" +
      "?product_id=" + productId + "&section_id=" + sectionId + "&limit=" + limit;
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var newSection = doc.querySelector(".related-products");
        if (newSection) container.innerHTML = newSection.innerHTML;
      })
      .catch(function () {});
  });
}());

  } catch(e) { console.error(e); }
})();
})();
